import type { CloudId } from '@atlassian/jira-shared-types/src/general.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

export const useCloudId = (): CloudId => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.cloudId;
};
